module.exports = __webpack_public_path__ + "static/media/save-the-date@2x.d76ab372.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/save-the-date@2x.png
 ** module id = 2106
 ** module chunks = 44
 **/